import React, { useEffect, useState, useMemo } from "react";
// import {
//   LeftOutlined,
//   PrinterOutlined,
//   DownloadOutlined,
//   ExperimentOutlined,
//   DownOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import MaterialTable from "@material-table/core";
// import { ExportCsv, ExportPdf } from "@material-table/exporters";
// import { Col, Row, Table, Divider } from "antd";
import * as traceAwareApi from "../../services/api/traceaware";
import { Link, useParams } from "react-router-dom";
import tableExport from "antd-table-export";
import moment from "moment";
// import CustomTable from "../../components/Table/CustomTable";
import { useTable, usePagination } from "react-table";
import { CSVLink } from 'react-csv';
// import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const TraceAwareTestLogs = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const { id } = useParams();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  // const [currentPage, setCurrentPage] = useState(0);

  // const [pagination, setPagination] = useState({
  //   pageIndex: 1,
  //   pageSize: 10,
  //   totalCount: 0
  // });

  // const [pageIndex, setPageIndex] = useState(0);
  // const pageSize = 10; // Set your desired page size
  const [filter, setFilter] = useState({
    filterBy: '',
    filterValue: ''
  });

  const getTraceAwareData = async () => {
    try {
      setLoading(true);
      var {
        data: { data, totalCount },
      } = await traceAwareApi?.getTraceaware();
      var dataList = [];

      console.log("Olfactory---------------------", data);
      data.master.forEach((element) => {
        // let newObj = element;
        let averageResponseTime = (
          (new Date(element.SessionEndTime.replace("T", " ")).getTime() -
            new Date(element.SessionStartTime.replace("T", " ")).getTime()) /
          (element.total * 1000) || 0
        ).toFixed(2);
        let recall = Math.round(getPercentage(element.Id, data.child, 1));
        let copy = Math.round(getPercentage(element.Id, data.child, 0));

        //let sStartTime = element.SessionStartTime.replace("T", " ");
        //let SessionStartTime = moment(sStartTime).format("MM/DD/Y HH:mm:ss");
        let SessionStartTime = moment(element.SessionStartTime).format(
          "MM/DD/Y HH:mm:ss"
        );

        // let sEndTime = element.SessionEndTime.replace("T", " ");
        // let SessionEndTime = moment(sEndTime).format("MM/DD/Y HH:mm:ss");
        let SessionEndTime = moment(element.SessionEndTime).format(
          "MM/DD/Y HH:mm:ss"
        );

        // let sCreateDate = element.dt_created.replace("T", " ");
        // let dt_created = moment(sCreateDate).format("MM/DD/Y HH:mm:ss");
        let dt_created = moment(element.dt_created).format("MM/DD/Y HH:mm:ss");

        const childerens = data.child.filter((ch) => ch.DSSTId === element.Id);

        childerens.forEach((childEle) => {
          var newObj = JSON.parse(JSON.stringify(element));

          newObj.recall = recall;
          newObj.copy = copy;
          newObj.SessionStartTime = SessionStartTime;
          newObj.SessionEndTime = SessionEndTime;
          newObj.dt_created = dt_created;
          newObj.averageResponseTime = averageResponseTime;
          newObj.ReferenceImageId = childEle.ReferenceImageId;
          newObj.RefernceImage = childEle.RefernceImage;
          newObj.DrawnImage = childEle.DrawnImage;
          newObj.GridVisibility = childEle.GridVisibility;
          newObj.FingerTouchCount = childEle.FingerTouchCount;

          dataList.push(newObj);
        });
      });

      // if (id) {
      //   dataList = dataList.filter((c) => c.UserId == userInfo.id);
      // }
      /* data.master = data.master.map((c) => ({
        ...c,
        averageResponseTime:
        
        ((new Date(c.SessionEndTime.replace("T", " ")).getTime() -
        new Date(c.SessionStartTime.replace("T", " ")).getTime()) /
        (c.total * 1000) || 0).toFixed(2),
        recall: Math.round(getPercentage(c.Id, data.child, 1)),
        copy: Math.round(getPercentage(c.Id, data.child, 0)),
        SessionStartTime:moment(c.SessionStartTime).format("MM:DD:Y hh:mm"),
        SessionEndTime:moment(c.SessionEndTime).format("MM:DD:Y hh:mm"),
        dt_created:moment(c.dt_created).format("MM:DD:Y hh:mm"),
        

        
      })); */

      // setData(data.master);
      setData(dataList);
      setFilterData(dataList);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getPercentage = (id, childs, checknumber) => {
    const childerens = childs.filter((ch) => ch.DSSTId === id);
    const recall = childerens.filter((c) => c.IsRecallImage == checknumber);
    const sum = recall.reduce((sum, cur) => {
      sum +=
        checknumber == 1 ? Number(cur.RecallAccuracy) : Number(cur.Accuracy);
      return sum;
    }, 0);
    return (sum / recall.length) * 100
      ? ((sum / recall.length) * 100).toFixed(2)
      : 0;
  };

  const columns = useMemo(
    () => [
      {
        Header: "TraceAware ID",
        accessor: "Id",
      },
      {
        Header: "StudyNumber",
        accessor: "StudyNumber",
      },
      {
        Header: "Researcher/PI",
        accessor: "UserId",
      },
      {
        Header: "Participant Id",
        accessor: "PatientId",
      },
      {
        Header: "Session Id",
        accessor: "SessionId",
      },
      {
        Header: "Session Start Time",
        accessor: "SessionStartTime",
      },
      {
        Header: "Session End Time",
        accessor: "SessionEndTime",
      },
      {
        Header: "Average Response Time (Second)",
        accessor: "averageResponseTime",
      },
      {
        Header: "Reference Image Id",
        accessor: "ReferenceImageId",
      },
      {
        Header: "Reference Image",
        accessor: "RefernceImage",
      },
      {
        Header: "Grid Visibility",
        accessor: "GridVisibility",
      },
      {
        Header: "Finger Touch Count",
        accessor: "FingerTouchCount",
      },
      {
        Header: "Drawn Image",
        accessor: "DrawnImage",
      },
      {
        Header: "Recall Accuracy (%)",
        accessor: "recall",
      },
      {
        Header: "Copying Accuracy (%)",
        accessor: "copy",
      },
      {
        Header: "Date",
        accessor: "dt_created",
      },
    ], []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // For pagination
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    setPageSize,
    previousPage,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize : 10 },
    },
    usePagination
  );
  // const columns = [
  //   {
  //     title: "TraceAwareID",
  //     field: "Id",
  //   },
  //   {
  //     title: "User Id",
  //     field: "UserId",
  //   },
  //   {
  //     title: "Session Id",
  //     field: "SessionId",
  //   },
  //   {
  //     title: "Session Start Time",
  //     field: "SessionStartTime",
  //   },
  //   {
  //     title: "Session End Time",
  //     field: "SessionEndTime",
  //   },
  //   /* {
  //     title: "Stuffy Nose",
  //     field: "IsStuffyNose",
  //     render: (IsStuffyNose) => (IsStuffyNose ? "True" : "False"),
  //   },
  //   {
  //     title: "There Loss Of Memory",
  //     field: "IsThereLossOfMemory",
  //     render: (IsThereLossOfMemory) => (IsThereLossOfMemory ? "True" : "False"),
  //   }, */

  //   {
  //     title: "Average Response Time (Second)",
  //     field: "averageResponseTime",
  //   },
  //   {
  //     title: "ReferenceImageId",
  //     field: "ReferenceImageId",
  //   },
  //   {
  //     title: "RefernceImage",
  //     field: "RefernceImage",
  //   },
  //   {
  //     title: "Grid Visibility",
  //     field: "GridVisibility",
  //   },
  //   {
  //     title: "FingerTouch Count",
  //     field: "FingerTouchCount",
  //   },
  //   {
  //     title: "DrawnImage",
  //     field: "DrawnImage",
  //   },
  //   {
  //     title: "Recall Accuracy (%)",
  //     field: "recall",
  //   },
  //   {
  //     title: "Copying Accuracy (%)",
  //     field: "copy",
  //   },
  //   {
  //     title: "Date",
  //     field: "dt_created",
  //   },
  // ];

  const exportInstance = new tableExport(data, columns);
  function downloadExcel() {
    exportInstance.download("TraceAwareTestLogs");
  }

  useEffect(() => {
    getTraceAwareData();
  }, []);

  // const paginatedData = useMemo(() => {
  //   const startIndex = pageIndex * pageSize;
  //   const endIndex = startIndex + pageSize;
  //   return data.slice(startIndex, endIndex);
  // }, [data, pageIndex, pageSize]);

  var returnPath = "/dashboard";
  if (id) {
    returnPath = "/dashboard/user-details/" + id;
  }


  useEffect(() => {
    const headers = columns.map(column => ({
      label: column.Header,
      key: column.accessor,
    }));
    setCsvHeaders(headers)
  }, [])

  const handleSearchFilter = (e) => {
    setFilter((state) => ({ ...state, filterValue: e.target.value }))

    if (e.target.value !== '') {

      const filteredData = filterData.filter(item => {
        if (typeof item[filter.filterBy] === 'string') {
          return item[filter.filterBy].toLowerCase().includes(e.target.value.toLowerCase());
        }
        // else if (typeof item[filter.filterBy] === 'number') {
        //   return item[filter.filterBy].toString().toLowerCase().includes(e.target.value.toLowerCase());
        // }
        return false;
      });
      setData(filteredData);
    }
    else {
      setData(filterData);
    }
  };

  const handleExportPDF = () => {
    const input = document.getElementById('tableToExport');

    const doc = new jsPDF();
    doc.autoTable({
      html: input,
      margin: { top: 10, right: 10, bottom: 10, left: 10 }, // Adjust margins as needed
      startY: 10, // Adjust starting position
      styles: { cellPadding: 1, fontSize: 8, valign: 'middle', overflow: 'linebreak' }, // Adjust cell styling
      headStyles: { fillColor: [100, 100, 255], textColor: 255, halign: 'center' }, // Adjust header styling
    });
    doc.save('sensify.pdf');
    doc.save('sensify.pdf');
  };

  // const getCurrentPageData = () => {
  //   const startIndex = (pageIndex - 1) * pageSize;
  //   const endIndex = startIndex + pageSize;
  //   return data.slice(startIndex, endIndex);
  // };

  const handlePageSizeChange = (e) => {
    const newSize = e.target.value ? Number(e.target.value) : 10;
    setPageSize(newSize);
  };

  const generateTimestampedFilename = useMemo(() => {
      let name = "TraceAware"
      const now = new Date();
      const pad = (num) => num.toString().padStart(2, '0');
      const year = now.getFullYear();
      const month = pad(now.getMonth() + 1);
      const day = pad(now.getDate());
      const hours = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      const seconds = pad(now.getSeconds());
      const timestamp = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
      let baseName = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
      return `${baseName}_${timestamp}.csv`;
    }, [])


  return (
    <>
      <section className="page_section ps-lg-4 pe-lg-5">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-2 col-md-6 col-sm-12 col-12  d-flex align-items-center">
              <div className="page_title d-flex align-items-center">
                <Link to={`/dashboard/${id ? encodeURIComponent(id) + "?type=clinicalTrialId" : ''}`}>
                  <svg width="40" height="40" className="me-3" viewBox="0 0 40 40" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <rect x="39" y="39" width="38" height="38" rx="19" transform="rotate(180 39 39)"
                      stroke="#101A36" stroke-width="2" />
                    <path
                      d="M24.9999 19L17.4099 19L20.7099 15.71C20.8982 15.5217 21.004 15.2663 21.004 15C21.004 14.7337 20.8982 14.4783 20.7099 14.29C20.5216 14.1017 20.2662 13.9959 19.9999 13.9959C19.7336 13.9959 19.4782 14.1017 19.2899 14.29L14.2899 19.29C14.1989 19.3851 14.1275 19.4973 14.0799 19.62C13.9799 19.8635 13.9799 20.1365 14.0799 20.38C14.1275 20.5028 14.1989 20.6149 14.2899 20.71L19.2899 25.71C19.3829 25.8037 19.4935 25.8781 19.6153 25.9289C19.7372 25.9797 19.8679 26.0058 19.9999 26.0058C20.1319 26.0058 20.2626 25.9797 20.3845 25.9289C20.5063 25.8781 20.6169 25.8037 20.7099 25.71C20.8036 25.617 20.878 25.5064 20.9288 25.3846C20.9796 25.2627 21.0057 25.132 21.0057 25C21.0057 24.868 20.9796 24.7373 20.9288 24.6154C20.878 24.4936 20.8036 24.383 20.7099 24.29L17.4099 21L24.9999 21C25.2651 21 25.5195 20.8946 25.707 20.7071C25.8945 20.5196 25.9999 20.2652 25.9999 20C25.9999 19.7348 25.8945 19.4804 25.707 19.2929C25.5195 19.1054 25.2651 19 24.9999 19Z"
                      fill="#101A36" />
                  </svg>
                  Test Logs
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-lg-0 mt-md-0 mt-3">
              <div className="view_test_button d-flex align-items-center">
                <CSVLink data={data} headers={csvHeaders} filename={generateTimestampedFilename}>
                  <button className="btn btn-primary bg-white">Export CSV</button>
                </CSVLink>
                <button className="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3" onClick={handleExportPDF}>Export PDF</button>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center mt-lg-0 mt-md-4 mt-3">
              <div className="view_test_button d-flex align-items-center">
                <div className="dropdown test_dropdown">
                  <select className=" btn btn-primary bg-white text-start" onChange={(e) => { setFilter((state) => ({ ...state, filterBy: e.target.value })) }}
                    defaultValue={filter.filterBy}>
                    {columns.map(column => {
                      return (<>
                        <option value={column.accessor}>{column.Header}</option>
                      </>)
                    })
                    }
                  </select>
                </div>
              </div>
              <div className="search_form ms-lg-4 ms-md-4 ms-4 w-100">
                <form action="">
                  <div className="input-group">
                    <button type="button" className="search_button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none">
                        <path
                          d="M21.07 16.83L19 14.71C18.5547 14.2868 17.9931 14.0063 17.3872 13.9047C16.7813 13.8032 16.1589 13.8851 15.6 14.14L14.7 13.24C15.7605 11.8229 16.2449 10.0567 16.0555 8.29684C15.8662 6.537 15.0172 4.91423 13.6794 3.7552C12.3417 2.59618 10.6145 1.98696 8.84565 2.05019C7.07678 2.11341 5.39754 2.84439 4.14596 4.09597C2.89438 5.34755 2.1634 7.0268 2.10017 8.79567C2.03695 10.5645 2.64617 12.2917 3.80519 13.6294C4.96421 14.9672 6.58699 15.8162 8.34683 16.0055C10.1067 16.1949 11.8729 15.7106 13.29 14.65L14.18 15.54C13.8951 16.0996 13.793 16.7346 13.8881 17.3553C13.9831 17.9761 14.2706 18.5513 14.71 19L16.83 21.12C17.3925 21.6818 18.155 21.9974 18.95 21.9974C19.745 21.9974 20.5075 21.6818 21.07 21.12C21.3557 20.8406 21.5828 20.5069 21.7378 20.1386C21.8928 19.7702 21.9726 19.3746 21.9726 18.975C21.9726 18.5754 21.8928 18.1798 21.7378 17.8114C21.5828 17.4431 21.3557 17.1094 21.07 16.83ZM12.59 12.59C11.8902 13.288 10.9993 13.7629 10.0297 13.9549C9.06017 14.1468 8.05549 14.047 7.14259 13.6682C6.2297 13.2894 5.44955 12.6485 4.9007 11.8265C4.35185 11.0046 4.05893 10.0384 4.05893 9.05C4.05893 8.06163 4.35185 7.09544 4.9007 6.27347C5.44955 5.45149 6.2297 4.81062 7.14259 4.43182C8.05549 4.05301 9.06017 3.95325 10.0297 4.14515C10.9993 4.33706 11.8902 4.812 12.59 5.51C13.0556 5.97446 13.4251 6.52621 13.6771 7.13367C13.9292 7.74112 14.0589 8.39233 14.0589 9.05C14.0589 9.70768 13.9292 10.3589 13.6771 10.9663C13.4251 11.5738 13.0556 12.1255 12.59 12.59ZM19.66 19.66C19.567 19.7537 19.4564 19.8281 19.3346 19.8789C19.2127 19.9297 19.082 19.9558 18.95 19.9558C18.818 19.9558 18.6873 19.9297 18.5654 19.8789C18.4436 19.8281 18.333 19.7537 18.24 19.66L16.12 17.54C16.0263 17.447 15.9519 17.3364 15.9011 17.2146C15.8503 17.0927 15.8242 16.962 15.8242 16.83C15.8242 16.698 15.8503 16.5673 15.9011 16.4454C15.9519 16.3236 16.0263 16.213 16.12 16.12C16.213 16.0263 16.3236 15.9519 16.4454 15.9011C16.5673 15.8503 16.698 15.8242 16.83 15.8242C16.962 15.8242 17.0927 15.8503 17.2146 15.9011C17.3364 15.9519 17.447 16.0263 17.54 16.12L19.66 18.24C19.7537 18.333 19.8281 18.4436 19.8789 18.5654C19.9296 18.6873 19.9558 18.818 19.9558 18.95C19.9558 19.082 19.9296 19.2127 19.8789 19.3346C19.8281 19.4564 19.7537 19.567 19.66 19.66Z"
                          fill="white" />
                      </svg>
                    </button>
                    <input type="search" className="form-control" placeholder="Search bar" onChange={(e) => { handleSearchFilter(e) }} aria-label="Username"
                      aria-describedby="basic-addon1" />
                  </div>
                </form>
              </div>
            </div>
          </div>



          {/* <CustomTable
            columns={columns}
            data={data}
            pagination={pagination}
            setPagination={setPagination}
            loading={loading}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          /> */}

          <div className="row mt-lg-5 mt-md-4 mt-4">
            <div className="col-12">
              <div className="test_table">
                <table className="table m-0" id="tableToExport" {...getTableProps()}>
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps()}>
                            {column.render("Header")}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  {
                    loading ? <span>Loading...</span> :
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map((cell) => (
                                <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                              ))}
                            </tr>
                          );
                        })}
                      </tbody>
                  }

                </table>
              </div>
            </div>
            <div className="col-12 mt-lg-3 pt-4">
              <div className="pagination d-flex align-items-center justify-content-between">
              <p className="m-0">Showing <b>{pageIndex * pageSize + 1}-{pageIndex * pageSize + page.length}</b> from <b>{data?.length}</b></p>
                <ul className="d-flex align-items-center">

                  <div className="pagination-select">
                    <select value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>
                  <li>
                    <div className="previour" onClick={() => previousPage()} disabled={!canPreviousPage}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none">
                        <path
                          d="M8.45977 12.71L14.1198 18.36C14.2127 18.4537 14.3233 18.5281 14.4452 18.5789C14.5671 18.6297 14.6978 18.6558 14.8298 18.6558C14.9618 18.6558 15.0925 18.6297 15.2144 18.5789C15.3362 18.5281 15.4468 18.4537 15.5398 18.36C15.726 18.1726 15.8306 17.9192 15.8306 17.655C15.8306 17.3908 15.726 17.1374 15.5398 16.95L10.5898 11.95L15.5398 6.99999C15.726 6.81263 15.8306 6.55918 15.8306 6.29499C15.8306 6.03081 15.726 5.77736 15.5398 5.58999C15.4472 5.49551 15.3367 5.42034 15.2148 5.36884C15.093 5.31734 14.9621 5.29054 14.8298 5.29C14.6975 5.29054 14.5666 5.31734 14.4447 5.36884C14.3228 5.42034 14.2124 5.49551 14.1198 5.58999L8.45977 11.24C8.35827 11.3336 8.27726 11.4473 8.22185 11.5738C8.16645 11.7003 8.13784 11.8369 8.13784 11.975C8.13784 12.1131 8.16645 12.2497 8.22185 12.3762C8.27726 12.5027 8.35827 12.6164 8.45977 12.71Z"
                          fill="#0096FF" />
                      </svg>
                    </div>
                  </li>
                  <li className="flex align-items-center mx-2">

                    {
                      (pageIndex == 2 || pageIndex == 1 || pageIndex == 0) &&
                      // Display spans around the current page
                      [0, 1, 2].map(option => (
                        <span
                          key={option}
                          className={pageIndex == 0 ? option + 1 === pageIndex + 1 ? 'pagination_count mx-2 active' : 'pagination_count  mx-2' : option + 1 === pageIndex ? 'pagination_count mx-2 active' : 'pagination_count  mx-2'}
                          onClick={() => gotoPage(option + 1)}
                        >
                          {option + 1} {/* Adding 1 here to display 1-based indexing */}
                        </span>
                      ))
                    }
                    {
                      pageIndex > 2 &&
                      // Display spans around the current page
                      [pageIndex - 1, pageIndex, pageIndex + 1].map(option => (
                        <span
                          key={option}
                          className={option === pageIndex ? 'pagination_count mx-2 active' : 'pagination_count  mx-2'}
                          onClick={() => gotoPage(option)}
                        >
                          {option} {/* Adding 1 here to display 1-based indexing */}
                        </span>
                      ))
                    }

                  </li>
                  <li>
                    <div className="next" onClick={() => nextPage()} disabled={!canNextPage}>
                      {/* <div className="next" disabled={!pagination.totalCount > pageSize * (pageIndex + 1)}> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none">
                        <path
                          d="M15.5402 11.29L9.88023 5.64001C9.78726 5.54628 9.67666 5.47188 9.5548 5.42111C9.43294 5.37035 9.30224 5.34421 9.17023 5.34421C9.03821 5.34421 8.90751 5.37035 8.78565 5.42111C8.66379 5.47188 8.55319 5.54628 8.46023 5.64001C8.27398 5.82737 8.16943 6.08082 8.16943 6.34501C8.16943 6.60919 8.27398 6.86264 8.46023 7.05001L13.4102 12.05L8.46023 17C8.27398 17.1874 8.16943 17.4408 8.16943 17.705C8.16943 17.9692 8.27398 18.2226 8.46023 18.41C8.55284 18.5045 8.66329 18.5797 8.78516 18.6312C8.90704 18.6827 9.03792 18.7095 9.17023 18.71C9.30253 18.7095 9.43342 18.6827 9.55529 18.6312C9.67717 18.5797 9.78761 18.5045 9.88023 18.41L15.5402 12.76C15.6417 12.6664 15.7227 12.5527 15.7781 12.4262C15.8336 12.2997 15.8622 12.1631 15.8622 12.025C15.8622 11.8869 15.8336 11.7503 15.7781 11.6238C15.7227 11.4973 15.6417 11.3836 15.5402 11.29Z"
                          fill="#0096FF" />
                      </svg>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
    // <div className="container">
    //   <div className="test-log">
    //     <span className="left-outlined">
    //       <Link to={returnPath}>
    //         <LeftOutlined />
    //       </Link>
    //     </span>
    //     <h2 style={{ fontSize: "32px", color: "white" }}>Test logs</h2>
    //   </div>

    //   <Divider />
    //   <Row className="table-background" gutter={[22, 22]}>
    //     <Col lg={24}>
    //       <MaterialTable
    //         title="TraceAware"
    //         columns={columns}
    //         data={data}
    //         options={{
    //           exportAllData: true,
    //           exportMenu: [
    //             {
    //               label: "Export PDF",
    //               exportFunc: (columns, data) =>
    //                 ExportPdf(columns, data, "TraceAware"),
    //             },
    //             {
    //               label: "Export CSV",
    //               exportFunc: (columns, data) =>
    //                 ExportCsv(columns, data, "TraceAware"),
    //             },
    //           ],
    //           filtering: true,
    //           sorting: true,
    //           headerStyle: {
    //             backgroundColor: "#01579b",
    //             color: "#FFF",
    //           },
    //           cellStyle: {
    //             backgroundColor: "#01579b",
    //             color: "#FFF",
    //           },
    //           pageSize: 10,
    //           pageSizeOptions: [10, 50, 100],
    //         }}
    //       />
    //     </Col>
    //   </Row>
    // </div>
  );
};

export default TraceAwareTestLogs;
